const INITIAL_STATE = {list: []}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'IDENTIFICADOR_TELEGRAM_FETCHED':
            return { ...state, list: action.payload.data }
        case 'IDENTIFICADOR_TELEGRAM_PAGE':
            return { ...state, paginaAtual: action.payload };
        default:
            return state
    }
}